import type { SelectedFilters } from '@/hooks/filters/useCompanyAttributesFilters';
import type { ThematicMeetingListParams } from '@/types/thematic-meetings';

type AttributeFilterParams = Pick<
    ThematicMeetingListParams,
    | 'departmentIds'
    | 'jobTitleIds'
    | 'managerIds'
    | 'companyAddressIds'
    | 'employeeLevelIds'
    | 'customAttributeIds'
>;

type FilterAttribute = { id?: string };

const toIds = (items: FilterAttribute[] | undefined): string[] | undefined => {
    const ids = (items ?? []).map((item) => item.id).filter((id): id is string => Boolean(id));
    return ids.length > 0 ? ids : undefined;
};

/**
 * Maps the shared company-attribute filter selection (`useCompanyAttributesFilters`, the same
 * hook the roster and the reports filter through) to the `/ThematicMeeting` list query's id-array
 * params — the same `departmentIds`/`jobTitleIds`/… naming already used by `toRosterParams`
 * (`src/utils/companyAttributeFilters.ts`) and the CompetencyMatrix report's
 * `buildReportFilterParams`, so the backend work this asks for is a small, familiar extension
 * rather than a new shape.
 */
export const toMeetingAttributeFilterParams = (
    filters: SelectedFilters,
): AttributeFilterParams => ({
    departmentIds: toIds(filters.departments),
    jobTitleIds: toIds(filters.jobTitles),
    managerIds: toIds(filters.managers),
    companyAddressIds: toIds(filters.companyAddresses),
    employeeLevelIds: toIds(filters.employeeLevels),
    customAttributeIds: toIds(filters.customAttributes),
});
